<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="BdrFws_1d01_P10 2er Kaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import BdrFws_1d01_P10 from '@/device-products/BdrFws_1d01_P10.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: BdrFws_1d01_P10, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } }, // swapped after FWR2018
      { id: 1, component: BdrFws_1d01_P10, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
